module.exports = __webpack_public_path__ + "img/2026-05-20.c2630530.jpg";